import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import cls from 'classnames';
import style from './index.module.scss';
import { eventEmitter } from '@/hooks/useAddDrawer';

import { addEventerHelper } from '@/utils';
import { AgreementListProps } from '@/pages/agreement/list';
import { ROUTER_MAP } from '@/types';

enum WIDTHTYPE {
  default,
  small,
}

// 自定义 Hook 来创建和管理抽屉
export function useDrawer() {
  const [componentList, setComponentList] = useState<any>([]);
  const listRef = useRef<any>([]);
  const [activeKey, setActiveKey] = useState<any>(0);
  const activeRef = useRef<HTMLDivElement>(null);
  // const [outKey, setOutKey] = useState<any>(0);
  // 抽屉容器
  const [ref, setRef] = useState<any>();
  const animationRef = useRef<Animation | null>(null);
  const [show, setShow] = useState(false);
  const size = useRef(WIDTHTYPE.default);

  useEffect(() => {
    if (ref) {
      animationRef.current = ref.animate(
        [
          { transform: 'translateX(100%)', opacity: 1 },
          { transform: 'translateX(0)', opacity: 1, offset: 0.9 },
          { opacity: 1 },
        ],
        {
          duration: 250, // 动画持续时间一秒
          easing: 'ease-in-out',
          fill: 'both',
          // iterations: Infinity, // 动画无限次数
        },
      );
      // 可以在这里控制动画，例如暂停或取消
      // animationRef.current?.pause();
      // animation.cancel();

      animationRef!.current!.onfinish = () => {
        setShow(true);
      };
    }
    return () => {
      animationRef.current?.cancel();
    };
  }, [ref]);

  const showDrawer = ({ renderDom, props, drawerType = WIDTHTYPE.default }) => {
    // 增加了 props 参数
    size.current = WIDTHTYPE.default ?? drawerType;
    const key = listRef.current.length + 1;
    let obj = {
      key: key,
      el: React.createElement(renderDom, {
        onClose: () => {
          hideDrawer({
            key: key,
          });
        },
        onCloseAll: () => {
          hideDrawer({
            key: false,
          });
        },
        ...props,
      }),
      size: WIDTHTYPE.default,
      closeClickModal: props.closeClickModal ?? true,
    };
    let res = [...listRef.current, obj];
    setComponentList(res);
    listRef.current = res;
    setActiveKey(key);
  };

  function hideDrawer({ key }) {
    let cannel;
    if (key && listRef.current.length > 1 && activeRef.current) {
      activeRef.current.classList.remove(style.come);
      activeRef.current.classList.add(style.out);
      cannel = addEventerHelper({
        event: 'animationend',
        element: activeRef.current,
        listener: () => {
          cannel();
          const list = listRef.current.filter((item) => item.key !== key);
          listRef.current = list;
          setComponentList(list);
          setActiveKey(list[list.length - 1]?.key);
          size.current = list[list.length - 1]?.size;
        },
      });
    } else {
      setShow(false);
      animationRef.current?.reverse();
      if (animationRef.current) {
        animationRef.current.onfinish = () => {
          setComponentList([]);
          listRef.current = [];
          setActiveKey(-1);
        };
      } else {
        setComponentList([]);
        listRef.current = [];
        setActiveKey(-1);
      }
    }
  }

  useEffect(() => {
    // console.log('[dev]看看-监听activeRef的变化:', activeRef);
  }, [activeRef]);

  // 抽屉组件，这里使用了 Portal 来渲染到 body 中
  const DrawerComponent = componentList.length ? componentList : null;

  // Portal 容器
  const drawerPortal =
    DrawerComponent &&
    ReactDOM.createPortal(
      <div className={cls(style.container, 'drawer')}>
        <div
          className={cls(style.mask, {
            [style.show]: show,
          })}
          onClick={() => {
            const item = listRef.current[listRef.current.length - 1];
            const key = item?.key;
            item.closeClickModal && hideDrawer({
              key: key,
            });
          }}
        />
        <div
          className={cls(style.loginBox, {
            [style.default]: size.current === WIDTHTYPE.default,
            [style.small]: size.current === WIDTHTYPE.small,
          })}
          ref={(e) => {
            setRef(e);
          }}
        >
          {DrawerComponent?.map((item, index) => {
            const { el, key } = item;
            return (
              <div
                key={key}
                className={cls(style.itemBox, 'drawer', {
                  [style.active]: activeKey === key,
                  [style.come]: index !== 0,
                  // [style.out]: index !== 0 && outKey === key
                })}
                ref={(e) => {
                  if (activeKey === item.key) {
                    activeRef.current = e;
                  }
                }}
              >
                {el}
              </div>
            );
          })}
        </div>
      </div>,
      document.body,
    );
  // 暴露方法和抽屉 Portal
  return { showDrawer, hideDrawer, drawerPortal };
}

export const showLoginDrawer = async (props = {}) => {
  const LazyLoginDrawer = React.lazy(() => import('../LoginPanel'));
  // 使用自定义 Hook
  // console.log('[dev]看看-Hookprops:', props);
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, drawerType: WIDTHTYPE.small });
};

export const showCardResetPassWord = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../ResetCardPassWord'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
  // CreateDrawer({ RenderDom: LazyLoginDrawer, zIndex: 1000, otherProps: props });
};

export const showSeclectCinema = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../SeclectCinemaDrawer'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
  // CreateDrawer({ RenderDom: LazyLoginDrawer, zIndex: 999, otherProps: props });
};
// 选择优惠卷
export const showCouponList = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../SeclectCoupon'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, drawerType: WIDTHTYPE.small });
  // CreateDrawer({ RenderDom: LazyLoginDrawer, zIndex: 999, otherProps: props });
};
/** 选择活动/会员卡优惠' */
export const showSelectActiveCard = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../SelectActiveCard'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};

export const showSelectSeat = async (props) => {
  // console.log('[dev]看看-123showSelectSeat');
  const LazyLoginDrawer = React.lazy(() => import('../../pages/seat/index'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });

  // CreateDrawer({ RenderDom: LazyLoginDrawer, zIndex: 999, otherProps: props });
};
// 选择会员卡支付
export const showSelectCardPay = async (props) => {
  // console.log('[dev]看看-123showSelectSeat', props);
  const LazyLoginDrawer = React.lazy(() => import('../CardList'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, drawerType: WIDTHTYPE.small });

  // CreateDrawer({ RenderDom: LazyLoginDrawer, zIndex: 999, otherProps: props });
};

export const showMy = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/user/index'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, router: ROUTER_MAP.USER_INDEX });
};
// 我的订单列表
export const showOrderList = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/order/list'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, router: ROUTER_MAP.ORDER_LIST });
};
// 我的优惠卷列表
export const showMyCouponList = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/coupon/list'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, drawerType: WIDTHTYPE.small });
};
// 用户协议
export const showAgreement = async (props: AgreementListProps) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/agreement/list'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
export const goLogoff = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/user/logoff'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
// 我的会员卡列表
export const showMyCard = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/card/list'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, router: ROUTER_MAP.CARD_LIST });
};
// 会员等级规则
export const showlevelRules = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/user/levelRules'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
// 购买会员卡
export const showBuyCard = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/card/sell'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props, router: ROUTER_MAP.CARD_SELL });
};

/**
 * 购卡协议
 */
export const showBuyCardAgreement = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/card/agreement'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
/**
 * 购卡说明
 */
export const showBuyCardDesc = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/card/desc'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
/**
 * 优惠卷详情
 */
export const showDiscountCouponDetails = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/coupon/details'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
/**
 * 充值赠礼
 */
export const showRechargeGift = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../../pages/card/recharge'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
/**
 * 影院列表
 */
export const showCinemaList = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../CinemaList'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};

// 会员卡输入密码
export const showCardPassword = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../CardPassword'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};
// 输入权益卡密码
export const showEquityCardPassword = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../EquityCardPassword'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};

/**
 * 组合优惠条案
 */
export const showCombineDiscount = async (props) => {
  const LazyLoginDrawer = React.lazy(() => import('../CombineDiscount'));
  eventEmitter.emit('showDrawer', { renderDom: LazyLoginDrawer, props });
};